export const RouteNames = {
  PATH_LOGIN: 'login',
  PATH_PRIVACY_POLICY: 'privacy-policy',
  PATH_USER_MANAGEMENT: 'user-management',
  PATH_ADMIN: 'admin',
  PATH_EVENT: 'event',
  PATH_TEMPORARY_FRONT_PAGE: 'kempire',
}
